import { BaseApi } from '@/main/baseApi';

import { DMS_MODULE, API_NAME } from './constants';


class SestavyApi extends BaseApi {
	async GetDailyPerformanceReport(params: any, languageId: any, columnsSeq: any) {
		return this.downloadXlsxReport(`/${DMS_MODULE}/DailyPerformance/GetDailyPerformanceReport?${params}&LanguageId=${languageId}&ColumnSequence=${columnsSeq}`, 'DailyPerformanceReport.xlsx');
	}

	constructor() {
		super(DMS_MODULE, API_NAME);
	}
}


export const apiProvider = new SestavyApi();
